import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PositionFromProps } from '../../utils/styledcomponents';
import type { PositionProps, SizeProps } from '../../utils/styledcomponents';
import { isFilename } from '../../assets/Assets';
import type { Image as ImageSrc } from '../../assets/Assets';

type Props = Required<SizeProps> & {
	className?: string;
	src: ImageSrc;
};

const FileImage = styled.img.attrs<Props>((props) => ({
	src: props.src
}))<Props>`
	object-fit: contain;
	height: ${(props) => props.height};
	width: ${(props) => props.width};
`;

const Image: FunctionComponent<Props> = (props: Props) => {
	const { className, src, width, height, ...otherProps } = props;

	if (isFilename(src)) {
		return (
			<FileImage
				className={className}
				src={src}
				width={width}
				height={height}
				{...otherProps}
			/>
		);
	} else {
		const ComponentImage = src;
		return (
			<ComponentImage
				className={className}
				width={width}
				height={height}
				{...otherProps}
			/>
		);
	}
};

const StyledImage = styled(Image)<{ inactive?: boolean }>`
	opacity: ${(props) => (props.inactive ? 0.5 : 1)};
`;

export default styled(StyledImage)<PositionProps>(PositionFromProps);
